(ns manage.content-variant-page.view.overview
  (:require ["@mui/material/Stack$default" :as Stack]
            [common.flags :refer [use-flag]]
            [common.mui :as mui]
            [common.ui.side-menu :as side-menu]
            [manage.adset.hooks :refer [use-adset]]
            [manage.content-variant-page.table.view :as variants-table]
            [manage.content-variant-page.view.entity :as entity]
            [uix.core :as uix :refer [$ defui]]))

(defui view
  [_]
  (let [content-optimizing-enabled? (use-flag :content-variant-content-optimizing)
        {:keys [targetType]} (use-adset)
        youtube? (= "youtube" targetType)
        menu-entries-cfg (entity/get-entity-config-entries content-optimizing-enabled? youtube?)]
    ($ Stack
       {:direction "row"
        :position "relative"
        :overflow "hidden"
        :flex 1
        :sx (fn [theme]
              #js {:borderTopStyle "solid"
                   :borderTopColor (mui/get-table-border-color theme)
                   :borderTopWidth "1px"})}
       ($ variants-table/variants-grid)
       ($ entity/current)
       ($ side-menu/side-menu {:menu-entries-cfg menu-entries-cfg}))))
